import { render } from "./OfferManager.vue?vue&type=template&id=8f4e898c&scoped=true"
import script from "./OfferManager.vue?vue&type=script&lang=js"
export * from "./OfferManager.vue?vue&type=script&lang=js"

import "./OfferManager.vue?vue&type=style&index=0&id=8f4e898c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8f4e898c"

export default script